/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-12-28 15:29:06
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-29 15:59:15
 * @FilePath: \ioc_base\src\modules\firePatrol\config\tables.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import i18n from "@src/common/lib/i18n";
import { Dic } from "$utils";
const tableOption = function () {
  // 123
  return {
    add: "新增",
    edit: "修改",
    view: "详情",
    stripe: true,
    page: true,
    maxHeight: "500px",
    align: "center",
    header: false,
    index: true,
    emptyText: i18n.t("cameraList.title.noData"),
    delBtn: false,
    editBtn: false,
    menu: false,
    column: [
      {
        label: "姓名",
        prop: "creatorName"
      },
      {
        label: "工号",
        prop: "creator"
      },
      {
        label: "部门",
        prop: "deptName"
      },
      {
        label: "手机号",
        prop: "phone"
      },
      {
        label: "巡查时间",
        prop: "createTime"
      }
    ]
  };
};

export default tableOption;
